<template>
  <div class="row result_row">
    <div class="col-3 thumbnail_container">
      <div class="thumbnail_container_inner" @click.stop="parent.goToProgramGuideDetail(source)">
        <template v-if="source.thumbnailURL">
          <img v-bind:src="source.thumbnailURL"
            alt="Img"
            class="thumb_img"
            onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
        </template>
        <template v-else>
          <div class="default_thumb">
            <span class="ic ic-degreeProgram" style="margin-top: 25px;"></span>
          </div>
        </template>
      </div>

      <div class="program_type" v-if="parent.showProgramTypeTagOnResult">
        <span v-if="source.type === 'MINOR'">Minor</span>
        <span v-if="source.type === 'CERT'">Certificate</span>
        <span v-if="source.type === 'WFT'">Workforce Training</span>
      </div>

      <div class="more_details">
        <template v-if="parent.isBookmarkEnabled">
          <span v-if="parent.showBookmarkOnResult && parent.isBookmarked(source)">
            <span class="ic_bm_container bookmarked ace_sec_txt" @click.stop.prevent="parent.deleteProgramGuideBookmark(source)" title="remove this programGuide from bookmark">
              <span class="icon ic8-bookmark3"></span>
            </span>
          </span>
          <span v-else-if="parent.showBookmarkOnResult && !parent.isBookmarked(source)">
            <span class="ic_bm_container ace_sec_txt" @click.stop.prevent="parent.bookmarkProgramGuide(source)" title="bookmark this career">
              <span class="icon ic8-bookmark3"></span>
            </span>
          </span>
        </template>

        <div class="program_desc">
          <b-link v-b-modal="'progDesc_' + source.uuid">more</b-link>

          <b-modal :id="'progDesc_' + source.uuid" hide-footer>
            <div slot="modal-header" class="row header-section">
              <div class="col-11 head_txt">{{ source.title }}</div>
              <div class="col-1 btn_container">
                <button type="button" class="btn_close" @click="parent.closeDescriptionModal('progDesc_' + source.uuid)" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>
            <div v-if="parent.showDescriptionOnResult && source.description" v-html="source.description"></div>
          </b-modal>
        </div>

      </div>

    </div>
    <div class="col-9 entity_details">
      <div class="row entity_title" @click.stop="parent.goToProgramGuideDetail(source)">
        <div class="title_txt">{{source.title}}</div>
      </div>
      <div class="row">
        <span v-if="parent.showCalculateRequiredCreditOnResult && parent.isStudentLogin && parent.planningStream" @click="parent.calculateCreditProgressClicked(source, $event)" style="color: #74aac2;">Calculate Required Credits</span>
      </div>
      <div v-if="source.lowestPriceCurrency && source.lowestPriceCurrency.length > 0" class="row list_info_row">
        <!--
        <div class="info_title">Pricing</div>
        -->
        <div class="info_val ace_sec_txt" v-if="source.lowestPrice" :aria-label="'Price is ' + source.lowestPrice + ' for this program guide'">
          <template v-if="parent.alreadyPurchased(source)">
          subscribed
          </template>
          <template v-else>
          Price is <span v-if="source.lowestPriceCurrency === 'usd'">$</span>{{source.lowestPrice}}
          </template>
        </div>
        <div class="info_no_val ace_sec_txt empty_pattern" v-else aria-label="growth rate is not available for this program guide">N/A</div>
      </div>
      <div v-if="!source.disableLMI" @click.stop="parent.goToProgramGuideDetail(source)">
        <div v-if="parent.showMedianIncomeOnResult" class="row oth_details">
          <div class="label">{{parent.medianIncomeResultLabel}}</div>
          <div class="val" v-if="source.medianIncomePerYear">
            {{parent.currencyLabel}} <span v-html="parent.addCommaInNumber(source.medianIncomePerYear)"></span>
          </div>
          <div class="val no_data" v-else>N/A</div>
        </div>
        <div v-if="parent.showJobPostingsOnResult" class="row oth_details">
          <div class="label">{{parent.jobPostingsResultLabel}}</div>
          <div  class="val"v-if="source.totalJobPostings">
            <span v-html="parent.addCommaInNumber(source.totalJobPostings)"></span>
          </div>
          <div class="val no_data" v-else>N/A</div>
        </div>
        <div v-if="parent.showGrowthRateOnResult" class="row oth_details">
          <div class="label">{{parent.growthRateResultLabel}}<span class="exclamation-circle" v-popover:tooltip="'Source: BLS. 2016-2026'"><span class="ico-error"></span></span></div>
          <div class="val" v-if="source.growthRate">
            <span v-html="parent.formatNumericVal(source.growthRate)"></span>%
          </div>
          <div class="val no_data" v-else>N/A</div>
        </div>
      </div>
    </div>
    <div class="row program_price" >
      <div class="col-12 filters_tag_row ace_sec_txt">
        <span class="cost" v-if="source.cost" :aria-label="'Cost  ' + source.cost + ' for this program guide'" > Cost ${{parent.addCommaInNumber(source.cost)}} </span>
        <span class="filter_tag" v-if="!source.freeProgram && source.pragyaProgram && source.lowestPrice === 0 && !source.paymentProcessedOutOfPragya" aria-label="program is coming soon" > Coming Soon</span>
        <span class="filter_tag" v-if="source.modalityType" :aria-label="'modalityType  ' + source.modalityType + ' for this program'" > {{parent.getModalityValue(source.modalityType)}} </span>
        <span class="filter_tag" v-if="source.fundingType" :aria-label="'fundingType  ' + source.fundingType + ' for this program'" > {{parent.getFundingValue(source.fundingType)}} </span>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'programItem',
  props: {
  	parent: {
  		type: Object
  	},
  	index: {
      type: Number
    },
    source: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/explore/components/ProgramItem.vue